exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.loupe_color-picker_1hE1x {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    border-radius: 100%;\r\n    border: 4px solid var(--ui-black-transparent);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"color-picker": "loupe_color-picker_1hE1x",
	"colorPicker": "loupe_color-picker_1hE1x"
};